/* eslint-disable no-shadow */
import Vue from 'vue';
import Proxy from '@/proxies/CustomerSearchProxy';
import Transformer from '@/transformers/CustomerTransformer';
import { i18n } from '@/plugins/vue-i18n';

export const getDefaultState = () => ({
  customerHash: null,
  name: null,
  firstname: null,
  salutation: null,
  dateOfBirth: null,
  customerNo: null,
  customerNoType: null,
  vbkz: null,
});

export const state = getDefaultState();

export const types = {
  RESET: 'RESET',
  RESTORE: 'RESTORE',
  SET: 'SET',
};

export const mutations = {
  [types.RESET](state) {
    Object.assign(state, getDefaultState());
    sessionStorage.removeItem('customer');
    Vue.$http.defaults.headers.common.customerHash = '';
  },

  [types.RESTORE](state) {
    try {
      // load for current tab first, then fallback to localStorage
      let customer = JSON.parse(sessionStorage.getItem('customer'));
      Object.assign(state, customer);

      Vue.$http.defaults.headers.common.customerHash = customer?.customerHash || '';
    } catch (e) {
      // payload invalid!
    }
  },

  [types.SET](state, customer) {
    Object.entries(getDefaultState()).forEach(([k, v]) => {
      state[k] = customer[k] !== undefined ? customer[k] : v;
    });

    sessionStorage.setItem('customer', JSON.stringify(state));

    Vue.$http.defaults.headers.common.customerHash = state.customerHash || '';
  },
};

export const getters = {};

export const actions = {
  reset({ commit }) {
    commit(types.RESET);
  },

  autoInit({ commit }) {
    commit(types.RESTORE);
  },

  async search({ commit, dispatch }, { form }) {
    const response = await new Proxy({ ...form, locale: i18n.locale }).all();

    const data = Transformer.fetch({ ...response });
    commit(types.SET, data);
    dispatch('contract/reset', null, { root: true });
    return data;
  },

  set({ commit }, customer) {
    const data = Transformer.fetch(customer);
    commit(types.SET, data);
  },
};
